var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1638501283471,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 5650,
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 213.44h298.88v597.12H64z",
    fill: "#002496",
    opacity: 0.75,
    "p-id": 5651
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64 213.44h16v597.12H64z",
    fill: "#002496",
    "p-id": 5652
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64 213.44h298.88v16H64v-16z m0 581.12h298.88v16H64v-16z",
    fill: "#002496",
    "p-id": 5653
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M660.672 213.44H960v597.12h-299.328z",
    fill: "#ED2938",
    opacity: 0.75,
    "p-id": 5654
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M944 213.44H960v597.12h-16z",
    fill: "#ED2938",
    "p-id": 5655
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M660.672 213.44H960v16h-299.328v-16z m0 581.12H960v16h-299.328v-16z",
    fill: "#ED2938",
    "p-id": 5656
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M362.88 213.44h297.792v597.12H362.88z",
    fill: "#FFFFFF",
    opacity: 0.75,
    "p-id": 5657
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M362.88 213.44h297.792v17.024H362.88v-17.024z m0 580.096h297.792v17.024H362.88v-17.024z",
    fill: "#EEEEEE",
    "p-id": 5658
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFr);
export default __webpack_public_path__ + "static/media/fr.b67b90e6.svg";
export { ForwardRef as ReactComponent };